import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import DailyUpdates from './components/DailyUpdates';
import CategoryNav from './components/CategoryNav';
import Testimonials from './components/Testimonials';
import Stats from './components/Stats';

export default function Home() {
  useEffect(() => {
    document.title = '韩国漫画网-好看的韩国漫画-韩漫在线免费阅读-无遮韩漫大全';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComics />
        <DailyUpdates />
        <CategoryNav />
        <Testimonials />
        <Stats />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "韩国漫画网-好看的韩国漫画-韩漫在线免费阅读-无遮韩漫大全",
          "description": "韩国漫画网收录好看的韩国漫画，支持韩漫在线免费阅读和无遮韩漫大全，界面友好操作简单，为您打造舒适阅读环境。",
          "url": "http://szfirstteam.com/",
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩国漫画网",
            "url": "http://szfirstteam.com/"
          }
        })}
      </script>
    </>
  );
}